import { APICore } from "helpers/api/apiCore";
import { FilterMetadata } from "redux/types";
import config from "config";
import { uploadBulkBeneficiaryFileType, BulkBeneficiaryDownloadFileType, BulkBeneficiaryFileDetail, BulkBeneficiaryFileVersionType, BulkBeneficiaryFileMakerRemarkType, BulkBeneficiaryFileCheckerRemarkType } from "./types";

const api = new APICore();

function uploadBulkBeneficiaryFileApi(params: uploadBulkBeneficiaryFileType) {
    let formData = new FormData();
    formData.append("file", params.bulkBeneficiaryFile);

    let backendApiUrl = `${config.BACKEND_BASE_URL}/bulk-file/customer_relationship_beneficiary`;

    const baseUrl = backendApiUrl;
    return api.create(`${baseUrl}`, formData);
}

function fetchBulkBeneficiaryFileApi(params: FilterMetadata) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/beneficiary`;
    return api.get(`${baseUrl}`, params);
}


function downloadBulkBeneficiaryFileApi(params: BulkBeneficiaryDownloadFileType) {
    const baseUrl = `${config.BACKEND_BASE_URL}${params.downloadURL}`;
    return api.getFile(`${baseUrl}`, {});
}

function fetchBulkBeneficiaryFileDetailApi(params: BulkBeneficiaryFileDetail) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/beneficiary/${params.externalID}`;
    return api.get(`${baseUrl}`, {});
}

function fetchBulkBeneficiaryFileVersionApi(params: BulkBeneficiaryFileVersionType) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/${params.externalId}/versions`;
    return api.get(`${baseUrl}`, params.filter);
}

function bulkBeneficiaryFilePublishApi(params: BulkBeneficiaryFileMakerRemarkType) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/${params.externalId}/publish`;
    return api.updatePatch(`${baseUrl}`, params.remarkPayload);
}

function approveBulkBeneficiaryFileApi(params: BulkBeneficiaryFileCheckerRemarkType) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/${params.externalId}/approve`;
    return api.updatePatch(`${baseUrl}`, params.remarkPayload);
}
function rejectBulkBeneficiaryFileApi(params: BulkBeneficiaryFileCheckerRemarkType) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/${params.externalId}/reject`;
    return api.updatePatch(`${baseUrl}`, params.remarkPayload);
}

function fetchBulkFileSpecificBeneficiaryApi(params: BulkBeneficiaryFileVersionType) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/customer_relationship_beneficiary/${params.externalId}/filerecords`;
    return api.get(`${baseUrl}`, params.filter);
}


function deleteBulkBeneficiaryFileApi(params: BulkBeneficiaryFileDetail) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/${params.externalID}`;
    return api.delete(`${baseUrl}`);
}

export {
    uploadBulkBeneficiaryFileApi,
    fetchBulkBeneficiaryFileApi,
    downloadBulkBeneficiaryFileApi,
    fetchBulkBeneficiaryFileDetailApi,
    fetchBulkBeneficiaryFileVersionApi,
    bulkBeneficiaryFilePublishApi,
    approveBulkBeneficiaryFileApi,
    rejectBulkBeneficiaryFileApi,
    fetchBulkFileSpecificBeneficiaryApi,
    deleteBulkBeneficiaryFileApi
}